import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ui-map-button',
    templateUrl: './map-button.component.html',
    styleUrls: ['./map-button.component.scss'],
    standalone: false,
})
export class MapButtonComponent {
    @Input()
    public noShadow = false;
}
